// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_1wl7y","bubble_text":"_28BD2","bubble_visible":"_2KCG4"};